import { FeedbackFormData } from '../../components/feedback-form/feedback-types';

export const soilCompactionFormData: FeedbackFormData = {
  id: 'soil-compaction',
  title: $localize`We'd like to hear some more`,
  subtitle: $localize`We promise it will only take a few minutes of your time, and your answers are of high value for us`,
  questions: [
    [
      {
        id: 'agree-extend',
        title: $localize`To what extent do you agree with the following statements?`,
        type: 'radio-block',
        options: [
          {
            id: 'route',
            label: $localize`The route you drive in the field can have a high impact on soil compaction`,
          },
          {
            id: 'plan',
            label: $localize`I am willing to plan in advance to minimize soil compaction`,
          },
          {
            id: 'soil-compaction',
            label: $localize`Minimizing soil compaction is more important than time and fuel consumption`,
          },
          {
            id: 'follow-route',
            label: $localize`I will follow a preplanned route in the field that is different from my usual driving pattern, if it can minimize soil compaction`,
          },
        ],
      },
      {
        id: 'would-use',
        title: $localize`Why would or wouldn't you use a tool like this?`,
        subtitle: $localize`Please add a comment below`,
        type: 'textarea',
      },
    ],
    [
      {
        id: 'planning',
        title: $localize`How are you planning how to drive the field today`,
        subtitle: $localize`Select the answer that best applies to your current practice`,
        type: 'radio',
        options: [
          {
            id: 'on-the-go',
            label: $localize`I plan on the go while driving`,
          },
          {
            id: 'map-tool',
            label: $localize`I plan in advance by using a map tool, like google maps`,
          },
          {
            id: 'field-tool',
            label: $localize`I plan in advance by using a tool for field planning`,
          },
        ],
        wildcard: {
          label: $localize`Other`,
          placeholder: '',
        },
      },
      {
        id: 'minimize',
        title: $localize`What do you do to minimize soil compaction today?`,
        subtitle: $localize`Select the answer that best applies to your current practice`,
        type: 'radio',
        options: [
          { id: 'nothing', label: $localize`I do nothing` },
          {
            id: 'before',
            label: $localize`Adjust tire pressure in the morning and/or in the evening`,
          },
          {
            id: 'on-field',
            label: $localize`Adjust tire pressure when entering and leaving the field`,
          },
          {
            id: 'after',
            label: $localize`Adjust tire pressure during the field operation`,
          },
        ],
        wildcard: {
          label: $localize`Other`,
          placeholder: '',
        },
      },
    ],
    [
      {
        id: 'consider',
        title: $localize`For which operation types would you consider using a tool for minimizing soil compaction?`,
        subtitle: $localize`Select one or more answers`,
        type: 'check-block',
        options: [
          { id: 'none', label: $localize`None` },
          { id: 'tillage', label: $localize`Tillage` },
          { id: 'seeding', label: $localize`Seeding` },
          { id: 'spraying', label: $localize`Spraying` },
          { id: 'slurry', label: $localize`Slurry application` },
          { id: 'harvesting', label: $localize`Harvesting` },
        ],
        wildcard: {
          label: $localize`Other`,
          placeholder: '',
        },
      },
      {
        id: 'imagine',
        title: $localize`How do you imagine using the output of this tool? `,
        subtitle: $localize`Select one or more answers`,
        type: 'check-block',
        options: [
          { id: 'paper', label: $localize`Printed on paper` },
          {
            id: 'online',
            label: $localize`Online on a tablet or smartphone`,
          },
          {
            id: 'terminal',
            label: $localize`I want to see the driving pattern in the tractor's terminal`,
          },
          {
            id: 'autosteering',
            label: $localize`I want to follow the preplanned route using the autosteering system in the tractor`,
          },
        ],
        wildcard: {
          label: $localize`Other`,
          placeholder: '',
        },
      },
    ],
    [
      {
        id: 'time-setting-up',
        title: $localize`How much time would you find reasonable to use on setting up a new tool like this? For example, entering master data like machinery, tire configurations etc.`,
        subtitle: $localize`Select the answer that fits best`,
        type: 'radio',
        options: [
          {
            id: 'no-time',
            label: $localize`I don't want to spend time on setting up a new tool`,
          },
          { id: '5-min', label: $localize`5 minutes` },
          { id: '15-min', label: $localize`15 minutes` },
          { id: '30-min', label: $localize`30 minutes` },
          { id: '1-hour', label: $localize`1 hour` },
          { id: 'more', label: $localize`> 1 hour` },
        ],
      },
      {
        id: 'time-planning',
        title: $localize`How much time would you spend on planning the routes for tomorrow's operations?`,
        subtitle: $localize`Select one answer`,
        type: 'radio',
        options: [
          {
            id: 'no-time',
            label: $localize`I don't want to spend time on planning in advance`,
          },
          { id: '1-min', label: $localize`1 minute` },
          { id: '5-min', label: $localize`5 minutes` },
          { id: '15-min', label: $localize`15 minutes` },
          { id: '30-min', label: $localize`30 minutes` },
          { id: 'more', label: $localize`> 30 minutes` },
        ],
      },
    ],
    [
      {
        id: 'price',
        title: $localize`At what price would you consider a product like this?`,
        subtitle: $localize`Please add a price in the four categories below, based on what you currently know about the idea - don't worry, you can't do anything wrong.`,
        type: 'pricing',
        options: [
          {
            id: 'too-low',
            label: $localize`At what price would you think the price is too low, that the product must be of bad quality? (Too cheap)`,
          },
          {
            id: 'good',
            label: $localize`At what price would you think the product is a bargain - a great buy for the money? (Cheap/Good value)`,
          },
          {
            id: 'expensive',
            label: $localize`At what price would you think the product is not out of the question, but you would have to give it some thoughts? (Expensive)`,
          },
          {
            id: 'too-expensive',
            label: $localize`At what price would you think the price is so expensive that you would not consider buying it? (Too expensive)`,
          },
        ],
      },
    ],
    [
      {
        id: 'anything-else',
        title: $localize`Anything else you'd like to share`,
        subtitle: $localize`Please add add any other comments, ideas and change requests, you would like to share with us`,
        type: 'textarea',
      },
      {
        id: 'email',
        title: $localize`E-mail contact`,
        subtitle: $localize`In case we need more information, we would like to contact you on the e-mail address you gave us when signing up.`,
        type: 'consent',
        options: [
          {
            id: 'mail',
            label: $localize`By ticking this box you allow us to get in contact with you by e-mail.`,
          },
        ],
      },
    ],
  ],
};
